import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import Home from '@/page/home.vue'
import AutoArea from '@/page/autoArea.vue'

const routes = [
  { path: '/', component: Home },
  // 汽车领域
  { path: '/autoArea', component: AutoArea },
  // worklist
  { path: '/WorkList', component: () => import('@/page/WorkList.vue') },
  // work
  { path: '/Work', component: () => import('@/page/Work.vue') },
  // contact
  { path: '/ContactUs', component: () => import('@/page/ContactUs.vue') },
  // about
  { path: '/about', component: () => import('@/page/about.vue') },
  // 云3D看车
  { path: '/Cloud3D', component: () => import('@/page/Cloud3D.vue') },
  // 品牌车型数字展厅
  { path: '/VehicleModel', component: () => import('@/page/VehicleModel.vue') },
  // 品牌智能技术展厅
  { path: '/intelligence', component: () => import('@/page/intelligence.vue') },
  // 车企全链路数字门店
  { path: '/Metaverse', component: () => import('@/page/Metaverse.vue') },
  // 应用服务-频道页
  { path: '/appService', component: () => import('@/page/appService.vue') },
  // 行业方法-频道页
  { path: '/industrySolutions', component: () => import('@/page/industrySolutions.vue') },
    // 详情页
  { path: '/detail', component: () => import('@/page/detail.vue') },
  { path: '/caseDetail', component: () => import('@/page/casedetail.vue') },
  { path: '/jishulujing', component: () => import('@/page/jishulujing.vue') },// 技术路径
  // 观点洞察
  { path: '/insight', component: () => import('@/page/insight.vue') },
  // 观点洞察详情（详情页待开发）
  { path: '/insightDetail', component: () => import('@/page/insightDetail.vue') },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 带 anchor 的跳转（行业解决方案的板块定位）直接滚动到对应板块，
    // 否则每次跳转的置顶会打断页内的平滑滚动
    if (to.path === '/industrySolutions' && to.query.anchor) {
      return { el: `#anchor-${to.query.anchor}`, behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

export default router
